import React, { useState, useEffect, useRef } from "react";

import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";

export default function NutzergrafikTermine({ users, termine, heading, graphDataBesichtigung }) {


   function renderCustomBarLabel({ payload, x, y, width, height, value, altLabel, isCurrency }) {
      return (
         <text x={x + width / 2} y={y} fill="#eef" fontWeight={500} textAnchor="middle" dy={-7}>
            {isCurrency ? (
               <tspan textAnchor="middle">
                  {new Intl.NumberFormat("de-DE", {
                     style: "currency",
                     currency: "EUR",
                     maximumFractionDigits: 0,
                  }).format(value)}
               </tspan>
            ) : (
               <tspan textAnchor="middle">{value ? value : ""}</tspan>
            )}
            {altLabel && (
               <tspan textAnchor="middle" x={x + width / 2} y={y - 24}>
                  {altLabel}
               </tspan>
            )}
         </text>
      );
   }

   return (
      <div className="projektstatus-l2 projektstatus-statistik">
         <div
            style={{
               margin: "auto",
               minWidth: "100%",
               maxWidth: "100vw",
            }}
         >
            <div>
               <h2 style={{ backgroundColor: "#0004", margin: 0, paddingTop: "8px" }}>{termine.length+ " "+ heading}</h2>
               <ResponsiveContainer
                  style={{ background: "linear-gradient(180deg, #0004 0%, #0000 100%)" }}
                  width={"100%"}
                  height={300}
               >
                  <BarChart
                     data={graphDataBesichtigung}
                     margin={{
                        top: 30,
                        right: 0,
                        left: 0,
                        bottom: 5,
                     }}
                  >
                     <XAxis dataKey="name" type="category" tick={{ fill: "#eef", fontSize: "x-small" }} />
                     <YAxis type="number" tick={{ fill: "#eef", fontSize: "small" }} />
                     <Tooltip />
                     <Legend /* content={(e)=>renderCustomLabel({...e})} */ />

                     
                     <Bar dataKey="Besichtigung bestätigt Vergangen" stackId="a" fill="#8EA7E9" label={renderCustomBarLabel} />
                     <Bar dataKey="Besichtigung Vergangen" stackId="a" fill="#8EA7E988" label={renderCustomBarLabel} />
                     <Bar dataKey="Besichtigung bestätigt Offen" stackId="b" fill="#E5E0FF" label={renderCustomBarLabel} />
                     <Bar dataKey="Besichtigung Offen" stackId="b" fill="#E5E0FF88" label={renderCustomBarLabel} />
                  </BarChart>
               </ResponsiveContainer>
            </div>
         </div>
      </div>
   );
}
